// extracted by mini-css-extract-plugin
export default {"paging_link":"pagination-link_paging_link__B7dbI","disabled":"pagination-link_disabled__-f1bf","current":"pagination-link_current__H5ZXN"};